import React from 'react';
import { Col, Input, Row } from 'reactstrap';
import Datetime from 'react-datetime';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

/**
 * Periodo superior de la pantalla de indicadores. Filtra los pagos del
 * embudo de adopción y las tarjetas de actividad por módulo.
 */
const IndicatorsPeriodFilter = ({
  globalPeriod,
  onGlobalPeriodChange,
  globalCustomDateRange,
  onGlobalDateRangeChange,
  onApplyGlobalCustomDateRange,
}) => (
  <Row className="mb-3">
    <Col md={4} className="mb-2 mb-md-0">
      <label className="mb-1 text-600" htmlFor="global-period-filter">Periodo superior</label>
      <Input id="global-period-filter" type="select" value={globalPeriod} onChange={(e) => onGlobalPeriodChange(e.target.value)}>
        <option value="current_month">Mes actual</option>
        <option value="current_year">Año actual</option>
        <option value="custom">Rango personalizado</option>
      </Input>
    </Col>
    {globalPeriod === 'custom' && (
      <>
        <Col md={3} className="mb-2 mb-md-0">
          <label className="mb-1 text-600" htmlFor="global-since-filter">Desde</label>
          <Datetime
            value={globalCustomDateRange.since}
            isValidDate={(current) => !current.isAfter()}
            onChange={(d) => onGlobalDateRangeChange('since', d)}
            dateFormat="DD/MM/YYYY"
            timeFormat={false}
            inputProps={{ id: 'global-since-filter', placeholder: 'DD/MM/AAAA' }}
          />
        </Col>
        <Col md={3} className="mb-2 mb-md-0">
          <label className="mb-1 text-600" htmlFor="global-to-filter">Hasta</label>
          <Datetime
            value={globalCustomDateRange.to}
            isValidDate={(current) => (!globalCustomDateRange.since || current.isAfter(globalCustomDateRange.since)) && !current.isAfter()}
            onChange={(d) => onGlobalDateRangeChange('to', d)}
            dateFormat="DD/MM/YYYY"
            timeFormat={false}
            inputProps={{ id: 'global-to-filter', placeholder: 'DD/MM/AAAA' }}
          />
        </Col>
        <Col md={2} className="mb-2 mb-md-0 d-flex align-items-end">
          <button
            type="button"
            className="btn btn-falcon-default w-100"
            onClick={onApplyGlobalCustomDateRange}
            disabled={!globalCustomDateRange.since && !globalCustomDateRange.to}
          >
            <FontAwesomeIcon icon={faSearch} className="mr-2" />
            Buscar
          </button>
        </Col>
      </>
    )}
  </Row>
);

export default IndicatorsPeriodFilter;
